var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconServiceType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ServiceType",
    transform: "translate(-446 -566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_784",
    "data-name": "Rectangle 784",
    transform: "translate(446 566)",
    fill: "none",
    stroke: "#0000b5",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 30,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 22.5,
    height: 28.5,
    rx: 1.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_format-list-checks",
    d: "M10.458,20.679,7.319,24.115,5.338,22.1l.99-.975.992,1.1,2.224-2.456.915.911Z",
    transform: "translate(447.542 562.759)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_format-list-checks-2",
    "data-name": "Path_format-list-checks",
    d: "M10.458,20.679,7.319,24.115,5.338,22.1l.99-.975.992,1.1,2.224-2.456.915.911Z",
    transform: "translate(456.422 562.759)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_format-list-checks-3",
    "data-name": "Path_format-list-checks",
    d: "M10.458,20.679,7.319,24.115,5.338,22.1l.99-.975.992,1.1,2.224-2.456.915.911Z",
    transform: "translate(447.542 567.3)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_format-list-checks-4",
    "data-name": "Path_format-list-checks",
    d: "M10.458,20.679,7.319,24.115,5.338,22.1l.99-.975.992,1.1,2.224-2.456.915.911Z",
    transform: "translate(456.422 567.3)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476",
    transform: "translate(448 570.59) rotate(-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_753919_tools_working_options_preferences_settings_icon",
    "data-name": "753919_tools_working_options_preferences_settings_icon",
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 3.233, 15.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    d: "M8.1,10.15a.558.558,0,0,0-.634-.11v0c-.033.011-.066.025-.1.035l-.03.013a.714.714,0,0,0-.538.6v.476a.476.476,0,0,1-.5.487H6.105c-.415.008-.49-.246-.5-.381v-.548c0-.5-.562-.643-.562-.643l0,0A4.115,4.115,0,0,1,4.181,9.7l-.033-.014a.711.711,0,0,0-.794.094l-.387.387c-.27.269-.47.144-.543.077l-.031-.032v0h0L2.074,9.9h0c-.249-.248.075-.59.118-.633l.377-.377h0a.689.689,0,0,0,.062-.743h0A4.108,4.108,0,0,1,2.284,7.3c0-.008-.006-.013-.009-.021a.74.74,0,0,0-.684-.521l-.367,0c-.429,0-.506-.278-.518-.425v-.3a.447.447,0,0,1,.481-.471h0l.47,0a.626.626,0,0,0,.6-.451c0-.006.005-.009.007-.015a4.061,4.061,0,0,1,.407-.981h0a.717.717,0,0,0-.138-.831l-.32-.319h0a.43.43,0,0,1-.024-.652l.167-.167a.489.489,0,0,1,.723,0h0l.363.363a.644.644,0,0,0,.749.1h0a4.1,4.1,0,0,1,.824-.349l.021-.011c.465-.183.552-.47.565-.618V1.094A.429.429,0,0,1,6.059.646H6.32A.466.466,0,0,1,6.8,1.16v.409a.7.7,0,0,0,.492.664h0a4.013,4.013,0,0,1,.776.307l0,0a.823.823,0,0,0,.982-.075l.283-.283c.013-.013.4-.383.682-.1h0l.234.234a.514.514,0,0,1-.074.7l-.317.317a.76.76,0,0,0-.09.851c0,.009,0,.014.008.023a4.092,4.092,0,0,1,.346.849l0,0s.1.514.561.513l.445,0h.032c.013,0,.543-.009.545.492v.211h0v.052c0,.124-.064.434-.557.436h-.427a.649.649,0,0,0-.573.45.512.512,0,0,0,.143.554l.061.06,0,0c.352.377.6-.151.6-.151a.644.644,0,0,1,.518-.327h.651a.358.358,0,0,0,.358-.358V5.34a.358.358,0,0,0-.358-.358h-.621a.635.635,0,0,1-.61-.452h0a4.923,4.923,0,0,0-.253-.608v0a.641.641,0,0,1,.161-.685l.4-.4a.359.359,0,0,0,0-.507L10.032,1.165a.359.359,0,0,0-.507,0l-.288.287a.757.757,0,0,1-.871.234h0a5.15,5.15,0,0,0-.5-.208L7.848,1.47a.744.744,0,0,1-.43-.695V.358A.358.358,0,0,0,7.06,0H5.34a.358.358,0,0,0-.358.358V.876a.569.569,0,0,1-.439.6l0,0a5.085,5.085,0,0,0-.555.232l-.008,0a.521.521,0,0,1-.606-.045l-.012-.012,0,0h0l-.484-.485a.359.359,0,0,0-.507,0L1.2,2.332a.358.358,0,0,0,0,.507l.388.389a.656.656,0,0,1,.17.689h0a4.934,4.934,0,0,0-.25.591c0,.011-.01.019-.015.031a.655.655,0,0,1-.573.443H.358A.358.358,0,0,0,0,5.34V6.993a.358.358,0,0,0,.358.358H1a.481.481,0,0,1,.459.336l0-.009a4.98,4.98,0,0,0,.265.674h0s.227.385-.027.64h0l-.5.5A.358.358,0,0,0,1.2,10l1.168,1.168a.357.357,0,0,0,.506,0l.45-.449h0l.02-.02a.614.614,0,0,1,.7-.046l.011,0a5.1,5.1,0,0,0,.491.2l0,0a.625.625,0,0,1,.44.573v.542a.358.358,0,0,0,.358.358H7.06a.358.358,0,0,0,.358-.358v-.594a.555.555,0,0,1,.374-.5l.029-.013c.119-.041.233-.092.349-.141.278-.154.02-.469.02-.469Z",
    transform: "translate(0 0)",
    fill: "#0000b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_753919_tools_working_options_preferences_settings_icon-2",
    "data-name": "753919_tools_working_options_preferences_settings_icon",
    transform: "translate(0.021 3.156) rotate(-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1436-2",
    "data-name": "Path 1436",
    d: "M8.1,10.15a.558.558,0,0,0-.634-.11v0c-.033.011-.066.025-.1.035l-.03.013a.714.714,0,0,0-.538.6v.476a.476.476,0,0,1-.5.487H6.105c-.415.008-.49-.246-.5-.381v-.548c0-.5-.562-.643-.562-.643l0,0A4.115,4.115,0,0,1,4.181,9.7l-.033-.014a.711.711,0,0,0-.794.094l-.387.387c-.27.269-.47.144-.543.077l-.031-.032v0h0L2.074,9.9h0c-.249-.248.075-.59.118-.633l.377-.377h0a.689.689,0,0,0,.062-.743h0A4.108,4.108,0,0,1,2.284,7.3c0-.008-.006-.013-.009-.021a.74.74,0,0,0-.684-.521l-.367,0c-.429,0-.506-.278-.518-.425v-.3a.447.447,0,0,1,.481-.471h0l.47,0a.626.626,0,0,0,.6-.451c0-.006.005-.009.007-.015a4.061,4.061,0,0,1,.407-.981h0a.717.717,0,0,0-.138-.831l-.32-.319h0a.43.43,0,0,1-.024-.652l.167-.167a.489.489,0,0,1,.723,0h0l.363.363a.644.644,0,0,0,.749.1h0a4.1,4.1,0,0,1,.824-.349l.021-.011c.465-.183.552-.47.565-.618V1.094A.429.429,0,0,1,6.059.646H6.32A.466.466,0,0,1,6.8,1.16v.409a.7.7,0,0,0,.492.664h0a4.013,4.013,0,0,1,.776.307l0,0a.823.823,0,0,0,.982-.075l.283-.283c.013-.013.4-.383.682-.1h0l.234.234a.514.514,0,0,1-.074.7l-.317.317a.76.76,0,0,0-.09.851c0,.009,0,.014.008.023a4.092,4.092,0,0,1,.346.849l0,0s.1.514.561.513l.445,0h.032c.013,0,.543-.009.545.492v.211h0v.052c0,.124-.064.434-.557.436h-.427a.649.649,0,0,0-.573.45.512.512,0,0,0,.143.554l.061.06,0,0c.352.377.6-.151.6-.151a.644.644,0,0,1,.518-.327h.651a.358.358,0,0,0,.358-.358V5.34a.358.358,0,0,0-.358-.358h-.621a.635.635,0,0,1-.61-.452h0a4.923,4.923,0,0,0-.253-.608v0a.641.641,0,0,1,.161-.685l.4-.4a.359.359,0,0,0,0-.507L10.032,1.165a.359.359,0,0,0-.507,0l-.288.287a.757.757,0,0,1-.871.234h0a5.15,5.15,0,0,0-.5-.208L7.848,1.47a.744.744,0,0,1-.43-.695V.358A.358.358,0,0,0,7.06,0H5.34a.358.358,0,0,0-.358.358V.876a.569.569,0,0,1-.439.6l0,0a5.085,5.085,0,0,0-.555.232l-.008,0a.521.521,0,0,1-.606-.045l-.012-.012,0,0h0l-.484-.485a.359.359,0,0,0-.507,0L1.2,2.332a.358.358,0,0,0,0,.507l.388.389a.657.657,0,0,1,.17.689h0a4.934,4.934,0,0,0-.25.591c0,.011-.01.019-.015.031a.655.655,0,0,1-.573.443H.358A.358.358,0,0,0,0,5.34V6.993a.358.358,0,0,0,.358.358H1a.481.481,0,0,1,.459.336l0-.009a4.98,4.98,0,0,0,.265.674h0s.227.385-.027.64h0l-.5.5A.358.358,0,0,0,1.2,10l1.168,1.168a.357.357,0,0,0,.506,0l.45-.449h0l.02-.02a.614.614,0,0,1,.7-.046l.011,0a5.1,5.1,0,0,0,.491.2l0,0a.625.625,0,0,1,.44.573v.542a.358.358,0,0,0,.358.358H7.06a.358.358,0,0,0,.358-.358v-.594a.555.555,0,0,1,.374-.5l.029-.013c.119-.041.233-.092.349-.141.278-.154.02-.469.02-.469Z",
    transform: "translate(0 0)",
    fill: "#0000b5"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 2.907,
    cy: 2.907,
    rx: 2.907,
    ry: 2.907,
    transform: "translate(4.551 4.722)",
    fill: "#0000b5"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_806",
    "data-name": "Rectangle 806",
    width: 2,
    height: 2,
    transform: "translate(450 589)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_808",
    "data-name": "Rectangle 808",
    width: 2,
    height: 2,
    transform: "translate(458.88 589)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_807",
    "data-name": "Rectangle 807",
    width: 2,
    height: 2,
    transform: "translate(450 584.038)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_809",
    "data-name": "Rectangle 809",
    width: 2,
    height: 2,
    transform: "translate(458.88 584.038)",
    fill: "#0000b5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServiceType);
export default __webpack_public_path__ + "static/media/icon-ServiceType.7246bad8177ce876b7be07200fd4a5ac.svg";
export { ForwardRef as ReactComponent };